<template>
  <div v-if="venue">
    <vs-tabs position="left" class="tabs-shadow-none mt-2" id="profile-tabs">
      <vs-tab icon-pack="feather" icon="icon-archive" label="Storages">
        <venue-storages />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-home" label="Locations">
        <venue-locations />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-airplay" label="Terminals">
        <venue-terminals />
      </vs-tab>
      <vs-tab icon-pack="feather" icon="icon-settings" label="Venue settings">
        <venue-settings />
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VenueStorages from "./VenueStorages.vue";
import VenueLocations from "./VenueLocations.vue";
import VenueTerminals from "./VenueTerminals.vue";
import VenueSettings from "./VenueSettings.vue";

export default {
  components: {
    VenueStorages,
    VenueLocations,
    VenueTerminals,
    VenueSettings,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {},
  computed: {
    ...mapGetters({
      venue: "pos/venues/venue",
    }),
  },
  async created() {
    const venueId = this.$route.params.id;
    await this.$store.dispatch("pos/venues/getVenue", venueId);
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
